import React,{useState} from "react";
import { Link } from "react-router-dom";

import bg1 from '../../assets/images/bg/bg-broker.png'
import business from '../../assets/images/svg/business-deal.svg'
import dashboard from '../../assets/images/saas/dashboard.png'

import Navbar from "../../components/navbar";
import Footer from "../../components/footer";
import ScrollTop from "../../components/scrollTop";
import CompanyLogo from "../../components/companyLogo";
import FooterTopTwo from "../../components/footerTopTwo";

import { brokerFeature, clientData } from "../../data/data";

import { MdOutlineCheckCircle, LiaFileInvoiceDollarSolid, RiFileShield2Line, LuUser2, BiChalkboard, FaRegChartBar } from '../../assets/icons/icons'

import TinySlider from "tiny-slider-react";
import 'tiny-slider/dist/tiny-slider.css';

export default function IndexBroker(){
    const [value, setValue] = useState(10000);
    let brokerage = parseFloat(value *0.01).toFixed(2)

    let settings = {
        container: '.tiny-single-item',
        items: 1,
        controls: false,
        mouseDrag: true,
        loop: true,
        rewind: true,
        autoplay: true,
        autoplayButtonOutput: false,
        autoplayTimeout: 3000,
        navPosition: "bottom",
        speed: 400,
        gutter: 16,
        responsive: {
            992: {
                items: 2
            },

            767: {
                items: 2
            },
            

            320: {
                items: 1
            },
        },
      };
    
    return(
        <>
        <Navbar navLight={true}/>

        <section className="bg-half-170 d-table w-100 bg-primary" style={{backgroundImage:`url(${bg1})`, backgroundPosition:'bottom'}}>
            <div className="container">
                <div className="row mt-5">
                    <div className="col-12">
                        <div className="heading-title">
                            <h5 className="text-white-50">Landflow Broker</h5>
                            <h4 className="display-4 fw-bold text-white title-dark">Find the best online <br/> broker for you</h4>
                            <p className="text-white-50 para-desc mb-0">Explore and learn more about everything from machine learning and global payments to  scaling your team.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <div className="position-relative">
            <div className="shape overflow-hidden text-white">
                <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
                </svg>
            </div>
        </div>

        <section className="section">
            <div className="container-fluid">
                <div className="features-absolute">
                    <div className="row">
                        {brokerFeature.map((item, index) =>{
                            let Icon = item.icon
                            return(
                                <div className="col-lg-2 col-md-4 mt-4 pt-2" key={index}>
                                    <div className="card border-0 text-center features feature-primary core-feature shadow rounded p-4">
                                        <div className="icon text-center mx-auto rounded-md">
                                            <h3 className="mb-0"><Icon/></h3>
                                        </div>
                                        <div className="card-body p-0 mt-4">
                                            <Link to="#" className="title text-dark h5">{item.title}</Link>
                                        </div>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>

            <div className="container mt-5">
                <div className="row">
                    <div className="col-12">
                        <ul className="list-unstyled text-muted h6 text-lg-center mb-0">
                            <li className="list-inline-item me-lg-5 me-4 ms-0"><span className="text-primary h3 me-2"><MdOutlineCheckCircle className="align-middle"/></span>Trusted by thousands of traders</li>
                            <li className="list-inline-item me-lg-5 me-4 ms-0"><span className="text-primary h3 me-2"><MdOutlineCheckCircle className="align-middle"/></span>100% free to use</li>
                            <li className="list-inline-item me-lg-5 me-4 ms-0"><span className="text-primary h3 me-2"><MdOutlineCheckCircle className="align-middle"/></span>Suggests regulated brokers</li>
                            <li className="list-inline-item me-lg-5 me-4 ms-0"><span className="text-primary h3 me-2"><MdOutlineCheckCircle className="align-middle"/></span>Work with any team</li>
                        </ul>
                    </div>
                </div>
            </div>

            <div className="container mt-100 mt-60">
                <div className="row justify-content-center">
                    <div className="col-12">
                        <div className="section-title text-center">
                            <h2 className="mb-4">The fastest way to find an <br/> online broker</h2>
                            <p className="text-muted para-desc mx-auto mb-0">Explore and learn more about everything from machine learning and global payments to  scaling your team.</p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container">
                <div className="row align-items-center">
                    <div className="col-md-6 order-1 order-md-2 mt-5 mt-lg-0">
                        <div className="section-title">
                            <h4 className="title mb-4">Great Service and Big Savings</h4>
                            <p className="para=desc text-muted">Regardless of how or what you trade, the broker you choose should be safe to use, affordable, and offer everything you need to trade at your best.</p>
                            <p className="para-desc text-muted">That’s why we’re highly selective. We only feature brokers regulated by a trusted authority and we make it easy to compare their fees & features, so that you can make an informed choice.</p>
                            <div className="mt-4">
                                <Link to="#" className="btn btn-primary">Learn More</Link>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6 order-2 order-md-1">
                        <img src={business} className="img-fluid" alt=""/>
                    </div>
                </div>
            </div>

            <div className="container mt-100 mt-60">
                <div className="row align-items-center">
                    <div className="col-lg-6">
                        <div className="section-title me-lg-5 mb-4 pt-2 mb-lg-0 pb-lg-0 text-lg-start text-center">
                            <h4 className="title mb-4">Brokerage Calculator</h4>
                            <p className="para-desc mx-auto ms-lg-0 text-muted">Use the brokerage calculator to calculate exactly how much you will pay in brokerage and your breakeven.</p>
                        </div>
                    </div>

                    <div className="col-lg-6 mt-4 mt-lg-0 pt-2 pt-lg-0">
                        <div className="p-4 shadow rounded" role="form">
                            <ul className="list-unstyled d-flex justify-content-between mb-0">
                                <li className="h6 mb-0">Min $ 10000</li>
                                <li className="h6 mb-0">Max $ 200000</li>
                            </ul>

                            <div className="row">
                                <div className="col-sm-12 mb-4">
                                    <label htmlFor="slider" className="form-label"></label>
                                    <input type="range" value={value} min="10000" onChange={(e) => setValue(e.target.value)} max="200000" className="form-range custom-range" id="slider"/>
                                </div>
                            </div>

                            <ul className="list-unstyled text-center d-md-flex justify-content-between mb-0">
                                <li>
                                    <ul className="mb-0 text-md-start brokerage-form list-unstyled">
                                        <li className="h5 mb-0"><label className="control-label">Total Value ($)</label></li>
                                        <li className="h5 mb-0"><input type="hidden" id="amount" className="form-control"/><span className="text-primary">${value}</span><p className="mb-0 d-inline-block h5 text-primary" id="amount-label"></p></li>
                                    </ul>
                                </li>

                                <li className="mt-2 mt-sm-0">
                                    <ul className="mb-0 text-md-end brokerage-form list-unstyled">
                                        <li className="h5 mb-0"><label className="control-label">Brokerage Fee</label></li>
                                        <li className="h5 mb-0"><input type="hidden" id="saving" className="form-control mb-0"/> <p className="mb-0 d-inline-block h5 text-primary" id="saving-label">{brokerage}</p></li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container mt-100 mt-60">
                <div className="row align-items-center">
                    <div className="col-md-6 order-1 order-md-2">
                        <div className="section-title">
                            <h4 className="title mb-4">We let data do the talking</h4>
                            <p className="para=desc text-muted">Regardless of how or what you trade, the broker you choose should be safe to use, affordable, and offer everything you need to trade at your best.</p>
                            <ul className="list-unstyled text-muted h6 mb-0">
                                <li className="list-inline-item me-lg-5 me-4 ms-0"><span className="text-primary h3 me-2"><LiaFileInvoiceDollarSolid /></span>Commissions & fees</li>
                                <li className="list-inline-item me-lg-5 me-4 ms-0"><span className="text-primary h3 me-2"><RiFileShield2Line /></span>Safety & regulation</li>
                                <li className="list-inline-item me-lg-5 me-4 ms-0"><span className="text-primary h3 me-2"><LuUser2 /></span>Customer service</li>
                                <li className="list-inline-item me-lg-5 me-4 ms-0"><span className="text-primary h3 me-2"><BiChalkboard /></span>Trading features</li>
                                <li className="list-inline-item me-lg-5 me-4 ms-0"><span className="text-primary h3 me-2"><FaRegChartBar /></span>Instruments</li>
                            </ul>    
                            <div className="mt-4">
                                <Link to="#" className="btn btn-primary">Learn More</Link>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6 order-2 order-md-1 mt-4 pt-2 mt-sm-0 pt-sm-0">
                        <div className="card border-0 shadow rounded me-lg-4">
                            <div className="p-2">
                                <Link to="#" className="text-danger"><i className="mdi mdi-circle"></i></Link>
                                <Link to="#" className="text-warning"><i className="mdi mdi-circle"></i></Link>
                                <Link to="#" className="text-success"><i className="mdi mdi-circle"></i></Link>
                            </div>
                            <div className="bg-light card-body p-md-4 p-2">
                                <img src={dashboard} alt="" className="img-fluid mx-auto d-block"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section className="section bg-light">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-12">
                        <div className="section-title mb-4 pb-2 text-center">
                            <h2 className="title mb-4">Used by thousands of traders like you</h2>
                            <p className="text-muted para-desc mx-auto mb-0">Explore and learn more about everything from machine learning and global payments to  scaling your team.</p>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-12 mt-4 pt-2">
                        <div className="tiny-two-item">
                            <TinySlider settings={settings}>
                                {clientData.map((item, index) =>{
                                    return(
                                        <div className="tiny-slide" key={index}>
                                            <div className="card border-0 customer-testi p-4 pt-5 shadow rounded-md m-2 overflow-hidden">
                                                <p className="text-muted fst-italic">{item.desc}</p>
                                                <div className="d-flex align-items-center mt-3">
                                                    <img src={item.image} className="img-fluid avatar avatar-small rounded-circle shadow" alt=""/>
                                                    <div className="flex-1 ms-3">
                                                        <h6 className="text-primary mb-0">{item.name}</h6>
                                                        <small className="text-muted">{item.title}</small>
                                                    </div>
                                                </div>
                                                <div className="quote">
                                                    <i className="mdi mdi-format-quote-close"></i>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })}
                            </TinySlider>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container mt-5">
               <CompanyLogo/>
            </div>
        </section>
        <FooterTopTwo/>
        <Footer/>
        <ScrollTop/>
        </>
    )
}